import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import React, {useEffect} from "react";
import api from "../../services/api";
import { toast } from "react-toastify";


const AtivarCampanha = ({open, onClose, data}) => {

    const handleClose = () => {
        //        setReload(!reload)
                onClose();
            };

    const handleDel = async () => {
        try {
            let res = await api.post(`/ativarCampanha`,data)
            if(res.status == 200){
                toast.info(`Campanha ativada com sucesso!`)
            }
            handleClose()
        } catch (error) {
            toast.error(`Erro ao ativar a campanha!`)
        }
    }

    return (
     <Dialog
     open={open}
     onClose={onClose}>
        <DialogTitle>
            Ativar Campanha
        </DialogTitle>
        <DialogContent dividers>
            <DialogContentText color="black">
            Deseja ativar a campanha: {data.name}?
            </DialogContentText>
        </DialogContent>
        <DialogActions>
        <Button
                    onClick={onClose}
                    color="secondary"
                    //disabled={isSubmitting}
                    variant="outlined"
                >
                    Sair
                </Button>
                <Button
                    onClick={handleDel}
                    color="primary"
                    //disabled={isSubmitting}
                    variant="contained"
                >
                    Ativar
                </Button>
        </DialogActions>
     </Dialog>       
    )
}

export default AtivarCampanha